import { useCallback, useRef } from 'react';
import useTimeout from '@restart/hooks/useTimeout';
import { useUncontrolledProp } from 'uncontrollable';
/**
 * Custom hook that provides show/hide handlers for an overlay trigger.
 * @returns An object containing the show/hide/toggle handlers and the current show state.
 */ export const useTriggerShowHandlers = ({ propsShow, defaultShow, onToggle, delay })=>{
    const hoverStateRef = useRef('');
    const timeout = useTimeout();
    const [show, setShow] = useUncontrolledProp(propsShow, defaultShow, onToggle);
    const toggleShow = useCallback((type)=>{
        timeout.clear();
        hoverStateRef.current = type;
        if (!delay.show) {
            setShow(type === 'show');
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === type) setShow(type === 'show');
        }, delay[type]);
    }, [
        delay.show,
        delay.hide,
        setShow,
        timeout
    ]);
    const handleShow = useCallback(()=>toggleShow('show'), [
        toggleShow
    ]);
    const handleHide = useCallback(()=>toggleShow('hide'), [
        toggleShow
    ]);
    const handleToggle = useCallback(()=>setShow(!show), [
        setShow,
        show
    ]);
    return {
        handleShow,
        handleHide,
        handleToggle,
        show
    };
};
